import React, { useMemo, useState } from 'react';
import { QUEUES, LOANS } from './data/mockData';
import { Loan } from './types';
import { TopBar } from './components/TopBar';
import { Sidebar } from './components/Sidebar';
import { DataTable } from './components/DataTable';
import { ContextPanel } from './components/ContextPanel';
import { AdminDrawer } from './components/AdminDrawer';
import { TakeOverModal } from './components/TakeOverModal';
const MY_QUEUE_ID = 'q8';
export function App() {
  const [loans, setLoans] = useState<Loan[]>(LOANS);
  const [activeQueueId, setActiveQueueId] = useState(QUEUES[0].id);
  const [selectedLoanId, setSelectedLoanId] = useState<string | null>(null);
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [takeOverLoanId, setTakeOverLoanId] = useState<string | null>(null);
  const [toast, setToast] = useState<string | null>(null);
  const [recentlyUpdatedQueueId, setRecentlyUpdatedQueueId] = useState<string | null>(null);
  const [updateNonce, setUpdateNonce] = useState(0);
  const flagQueueUpdated = (queueId: string) => {
    setRecentlyUpdatedQueueId(queueId);
    setUpdateNonce(n => n + 1);
    window.setTimeout(() => setRecentlyUpdatedQueueId(null), 2600);
  };
  const queuesWithCounts = useMemo(() => QUEUES.map(q => ({
    ...q,
    count: loans.filter(l => l.queueId === q.id).length
  })), [loans]);
  const activeQueue = queuesWithCounts.find(q => q.id === activeQueueId) || queuesWithCounts[0];
  const queueLoans = loans.filter(l => l.queueId === activeQueueId);
  const selectedLoan = loans.find(l => l.id === selectedLoanId) || null;
  const takeOverLoan = loans.find(l => l.id === takeOverLoanId) || null;
  const handleSelectQueue = (id: string) => {
    setActiveQueueId(id);
    setSelectedLoanId(null);
  };
  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(null), 3200);
  };
  const handleClaimLoan = (loanId: string) => {
    const target = loans.find(l => l.id === loanId);
    if (!target) return;
    setLoans(prev => prev.map(l => l.id === loanId ? {
      ...l,
      queueId: MY_QUEUE_ID,
      claimState: 'In Progress - Loan Claimed',
      lastUpdate: new Date().toISOString().split('T')[0]
    } : l));
    setActiveQueueId(MY_QUEUE_ID);
    setSelectedLoanId(loanId);
    flagQueueUpdated(MY_QUEUE_ID);
    showToast(`${target.name} claimed and moved to My Claimed Loans`);
  };
  const handleConfirmTakeOver = (loanId: string) => {
    const target = loans.find(l => l.id === loanId);
    if (!target) return;
    setLoans(prev => prev.map(l => l.id === loanId ? {
      ...l,
      queueId: MY_QUEUE_ID,
      claimState: 'In Progress - Taken Over',
      partner: 'You',
      lastUpdate: new Date().toISOString().split('T')[0]
    } : l));
    setTakeOverLoanId(null);
    setActiveQueueId(MY_QUEUE_ID);
    setSelectedLoanId(loanId);
    flagQueueUpdated(MY_QUEUE_ID);
    showToast(`You are now Loan Officer on ${target.name}. Previous owner notified.`);
  };
  return <div className="h-screen w-full flex flex-col bg-slate-100 font-sans overflow-hidden text-slate-900" data-id="element-0">
      <TopBar onOpenAdmin={() => setIsAdminOpen(true)} data-id="element-1" />

      <div className="flex-1 flex overflow-hidden" data-id="element-2">
        <Sidebar queues={queuesWithCounts} activeQueueId={activeQueueId} onSelectQueue={handleSelectQueue} recentlyUpdatedQueueId={recentlyUpdatedQueueId} updateNonce={updateNonce} data-id="element-3" />

        <main className="flex-1 flex overflow-hidden" data-id="element-4">
          <DataTable queue={activeQueue} loans={queueLoans} selectedLoanId={selectedLoanId} onSelectLoan={setSelectedLoanId} onClaimLoan={handleClaimLoan} onRequestTakeOver={id => setTakeOverLoanId(id)} data-id="element-5" />

          <ContextPanel loan={selectedLoan} queue={activeQueue} onClose={() => setSelectedLoanId(null)} onClaimLoan={handleClaimLoan} onRequestTakeOver={id => setTakeOverLoanId(id)} data-id="element-6" />
        </main>
      </div>

      <AdminDrawer isOpen={isAdminOpen} onClose={() => setIsAdminOpen(false)} queues={queuesWithCounts} data-id="element-7" />

      <TakeOverModal loan={takeOverLoan} onClose={() => setTakeOverLoanId(null)} onConfirm={handleConfirmTakeOver} data-id="element-8" />

      {toast && <div className="fixed bottom-6 right-6 z-50 bg-slate-900 text-white text-sm font-medium px-4 py-3 rounded-lg shadow-xl flex items-center gap-2" data-id="element-9">
          <div className="w-1.5 h-1.5 rounded-full bg-emerald-400" data-id="element-10" />
          {toast}
        </div>}
    </div>;
}